"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlgoliaRecommendations = void 0;
const helper_1 = require("../helper");
const types_1 = require("../types");
const getAlgoliaRecommendations = async ({ productIds, indexName, client, maxRecommendations = 12, filter, options, }) => {
    if (!productIds.length) {
        return [];
    }
    const recommendationsPerProduct = Math.round(maxRecommendations / productIds.length);
    const multiQueryResponse = await client.getRelatedProducts(productIds.map((productId) => ({
        objectID: productId,
        maxRecommendations: recommendationsPerProduct,
        indexName,
        queryParameters: (0, helper_1.getSearchOptions)(types_1.ObjectType.Product, {
            filter,
        }, {
            ...options,
            analyticsTags: Array.from(new Set([productId, ...(options?.analyticsTags || [])])),
        }),
    })));
    const searchResponses = multiQueryResponse.results.reverse();
    const recommendations = [];
    for (let i = 0; i < searchResponses[0].hits.length; i += 1) {
        for (let j = 0; j < searchResponses.length; j += 1) {
            recommendations.push((0, helper_1.mapAlgoliaProductToProduct)(searchResponses[j].hits[i], searchResponses[j].queryID));
        }
    }
    return recommendations;
};
exports.getAlgoliaRecommendations = getAlgoliaRecommendations;
//# sourceMappingURL=getRecommendations.js.map